<template>
    <div class="filter">
        <div class="controls">
            <span>FILTRER: </span>
            <div class="filter-box">
                <input type="checkbox" id="BAN"
                       value="ban"
                       @change="$emit('change-filter', filterChecked)"
                       v-model="filterChecked">
                <label for="BAN">BANS</label>
            </div>
            <div class="filter-box">
                <input type="checkbox" id="MUTE"
                       value="mute"
                       @change="$emit('change-filter', filterChecked)"
                       v-model="filterChecked">
                <label for="MUTE">MUTES</label>
            </div>
            <div class="filter-box">
                <input type="checkbox" id="KICK"
                       value="kick"
                       @change="test()"
                       v-model="filterChecked">
                <label for="KICK">KICKS</label>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                filterChecked: ['kick', 'mute', 'ban'],
            }
        },
        props: ['filter'],
        mounted() {
            if (this.filter !== null && this.filter !== undefined && this.filter.length > 0) {
                this.filterChecked = this.filter.split(",");
            }
        },
        methods: {
            test() {
                this.$emit('change-filter', this.filterChecked)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .filter {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 20px;
        font-size: 80%;
        color: #7c8084;

        .controls {
            display: flex;
            align-items: center;
            background: #262a2d;
            padding: 3px 3px 3px 10px;
            border-radius: 3px;
            line-height: 24px;

            > span {
                letter-spacing: .5px;
                font-weight: bold;
                padding-right: .8rem;
            }

            .filter-box {
                display: inline-block;
                margin: .25rem .8rem .25rem 0;
                min-height: 1.5rem;
                padding-left: 1.5rem;


                input {
                    position: absolute;
                    z-index: -1;
                    opacity: 0;

                    &:checked ~ label:before {
                        background-color: #131517;
                    }

                    &:checked ~ label:after {
                        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3E%3C/svg%3E");
                    }
                }

                label {
                    position: relative;
                    margin-bottom: 0;
                    vertical-align: top;
                    user-select: none;

                    &:before {
                        background-color: #40444b;
                        color: #fff;
                        border-radius: .25rem;
                        transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
                        position: absolute;
                        top: .15rem;
                        left: -1.4rem;
                        display: block;
                        width: 1rem;
                        height: 1rem;
                        content: "";
                    }

                    &:after {
                        transition: .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
                        background: no-repeat 50%/50% 50%;
                        position: absolute;
                        top: .05rem;
                        left: -1.4rem;
                        display: block;
                        width: 1rem;
                        height: 1rem;
                        content: "";
                        z-index: 5;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 990px) {
        .filter {
            display: block;

            .controls {
                justify-content: space-around;
            }
        }
    }
</style>